export class License {
  constructor(
    public docType: string,
    public licenseKey: string,
    public orderRef: string,
    public startDate: string,
    public endDate: string,
    public externalProductId: string,
    public purchasedSeats: number,
    public notes: string,
    public id?: string,
  ) {}
}
